"use client";

import { motion } from "framer-motion";
import { StaticImageData } from "next/image";
import { forwardRef } from "react";

interface SlideProps {
  header: string;
  text: string;
  image: StaticImageData;
}

// Use forwardRef to pass the ref to the <li> element
export const Slide = forwardRef<HTMLLIElement, SlideProps>(({ header, text, image }, ref) => {
  return (
    <motion.li
      layout
      initial={false} // skip the mount animation
      transition={{ duration: 0.4, ease: "easeInOut" }}
      ref={ref}
      className="slide absolute right-0 left-0 mx-auto flex h-32 rounded-xs bg-card md:h-52"
    >
      <div
        className="h-full w-10 bg-cover bg-center md:w-32"
        style={{ backgroundImage: `url(${image.src})` }}
      ></div>
      <div className="flex flex-col justify-between px-2 py-4 text-primary md:p-8">
        <h2 className="text-md font-mono uppercase md:text-2xl">{header}</h2>
        <p className="font-sans text-[16px] md:text-xl">{text}</p>
      </div>
    </motion.li>
  );
});

Slide.displayName = "Slide";
